module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("Dante Black")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("How do you stop a storm that has already been brewing, set in a path to wipe out all that stands in its way?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Dante Black")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("It's time to make my move. I've shown the princess some mercy. Instead of hitting hard on her, I diverted the attention of the Inner Circle to another. Now they have issued an order for me to move or they will send someone else who won't hesitate to finish the job.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("My own father, Cole Black.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("If you think I'm a monster, then you will think he's the devil. He once killed me off, only to resurrect me into his own likeness, but without a human heart which was replaced with a metal one.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Summer was the one who brought my metal heart back to life, though.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Too bad, she's also the Princess I was sent to destroy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("***Claiming the Crown is the third book in the USA Today Bestselling New Adult Contemporary RH Dark Romance Series, Hidden Falls High, a prequel series from the Loving Summer Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Prologue")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d5053e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c002.vue
// module id = 63
// module chunks = 0